"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
var React = require("react");
var Renderer_1 = require("../renderer/Renderer");
var useCache_1 = require("../cache/useCache");
var useCluster_1 = require("../cluster/useCluster");
var CacheCluster = function (props) {
    var _a = React.useState(), map = _a[0], setMap = _a[1];
    var cached = useCache_1.useCache(props.cacheConfig);
    var clustered = useCluster_1.useCluster(props.clusterConfig, props.clusterer, cached.pins);
    var _b = React.useState(null), extraPins = _b[0], setExtraPins = _b[1];
    var _c = React.useState([]), allPins = _c[0], setAllPins = _c[1];
    var _d = React.useState(props.camera), camera = _d[0], setCamera = _d[1];
    var onViewportChanged = function (newViewport) {
        cached.onViewportChanged(newViewport);
        clustered.onViewportChanged(newViewport);
        props.onViewportChanged(newViewport);
    };
    var onCancel = function () { return props.onCancel(); };
    var onMapReady = function (map) {
        cached.setMap(map);
        clustered.setMap(map);
        props.onMapReady(map);
        setMap(map);
    };
    React.useEffect(function () {
        cached.addCacheData(props.cacheData);
    }, [props.cacheData]);
    React.useEffect(function () {
        setCamera(props.camera);
    }, [props.camera]);
    React.useEffect(function () {
        setExtraPins(props.extraPins);
    }, [props.extraPins]);
    React.useEffect(function () {
        var notIn = function (pins) { return function (pin) {
            var existingPin = pins.find(function (it) { return it.lat === pin.lat && it.lng === pin.lng; });
            if (existingPin)
                return false;
            return true;
        }; };
        var clusteredPins = extraPins && extraPins.length ?
            clustered.pins
                .map(function (it) { return (__assign(__assign({}, it), { unfocus: true })); })
                .filter(notIn(extraPins)) :
            clustered.pins;
        var allPins = clusteredPins.concat(extraPins && extraPins.length ? extraPins : []);
        setAllPins(allPins);
    }, [clustered.pins, extraPins]);
    return (React.createElement("div", { style: { flexDirection: 'column', width: '100%', height: '100%', display: 'flex' } },
        React.createElement(Renderer_1.Renderer, { pins: allPins, camera: camera, pinRenderer: props.pinRenderer, onViewportChanged: onViewportChanged, onCancel: onCancel, onMapReady: onMapReady, minZoom: props.minZoom, zoomControl: props.zoomControl })));
};
exports["default"] = CacheCluster;
